import { render, staticRenderFns } from "./examSetting.vue?vue&type=template&id=7c09f894&scoped=true&"
import script from "./examSetting.vue?vue&type=script&lang=js&"
export * from "./examSetting.vue?vue&type=script&lang=js&"
import style0 from "./examSetting.vue?vue&type=style&index=0&id=7c09f894&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09f894",
  null
  
)

export default component.exports